var $ = require('jquery');
require('fg-frontend/ramjet/partialUpdate');
'use strict';

var Utils = function() {

};

Utils.prototype.removeDiacritics = function(str) {
	var sdiak = [/[áäàâãå]/g, /[čćĉ]/g, /[ď]/g, /[éěèêë]/g, /[íìîï]/g, /[ĺľ]/g, /[ňñ]/g, /[óòôö]/g, /[ŕř]/g, /[šśŝ]/g, /[ť]/g, /[úůüùûű]/g, /[ýÿŷ]/g, /[ž]/g, /[ÁÄÀÂÃÅ]/g, /[ČĆĈ]/g, /[Ď]/g, /[ÉĚÈÊË]/g, /[ÍÌÎÏ]/g, /[ĹĽ]/g, /[ŇÑ]/g, /[ÓÒÔÖ]/g, /[ŔŘ]/g, /[ŠŚŜ]/g, /[Ť]/g, /[ÚŮÜÙÛŰ]/g, /[ÝŶŸ]/g, /[Ž]/g];
	var bdiak = ["a","c","d","e","i","l","n","o","r","s","t","u","y","z","A","C","D","E","I","L","N","O","R","S","T","U","Y","Z"];
	for (var i=0; i < sdiak.length; i++) {
		str = str.replace((sdiak[i]), bdiak[i]);
	}
	return str;
};

Utils.prototype.executePartialUpdate = function(url, widgetId, customProperties, callback) {
	customProperties = customProperties || {};
	customProperties = $.extend(true, {}, {alterHistory: false, clearCache: true}, customProperties);
	$.partialUpdate.execute(url, widgetId, callback, customProperties);
};

Utils.prototype.saveStateToHistory = function(key, data) {
	if (history && history.pushState) {
		var state = history.state || {};
		state[key] = data;
		history.pushState(state, document.title, window.location.href);
	}
};

module.exports = Utils;


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/utils.js